/*=========================================================================================
  File Name: moduleImmoGetters.js
  Description: Immo Module Getters
==========================================================================================*/


export default {};